import type { Route } from 'next';
import type { ReactNode } from 'react';

import { ArticleItemBody } from '#components/Article/Items/ArticleItemBody';
import { ArticleItemImage } from '#components/Article/Items/ArticleItemImage';
import { ArticleItemTitleLink } from '#components/Article/Items/ArticleItemTitleLink';

import styles from './BoardSectionItemHighlight.module.scss';

type Props = {
	image?: ReactNode;
	onClick?: () => void;
	path: Route;
	title: string;
	className?: string;
};

export function BoardSectionItemHighlight({ image, onClick, path, title, className = '' }: Props) {
	return (
		<article className={`${styles.wrapper} ${className}`} onClick={onClick}>
			<header className={styles.header}>
				<ArticleItemImage image={image} path={path} title={title} />
			</header>

			<ArticleItemBody className={styles.body}>
				<ArticleItemTitleLink className={styles.title} path={path}>
					{title}
				</ArticleItemTitleLink>
			</ArticleItemBody>
		</article>
	);
}
